export default "__VITE_ASSET__jVFmwHpw__"